export default {
  type: "map",
  style: "",
  url: "https://www.radicasys.com",
  children: [],
};
